<template>
	<div>
		<el-card>
			<div slot="header" class="clearfix">
				<i class="el-icon-back backIcon" @click='goBack'></i>
				<span class="topTitle">视频详情</span>
			</div>
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="中文" name="zh">
					<div class="flex">
						<div class="title">视频标题：</div>
						<div class="">{{addBody.title}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频封面：</div>
						<ImageDetailVue :imgUrl="addBody.icon" style="width: 200px;height: auto;"></ImageDetailVue>
						<!-- <img :src="imgDomain+addBody.icon" style="width: 200px;height: auto;" /> -->
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频：</div>
						<video autoplay controls muted :src="imgDomain+addBody.file" loop width="500" height="300">
						</video>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频URL：</div>
						<a :href="addBody.url">{{addBody.url}}</a>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">创建时间：</div>
						<div class="">{{addBody.create_time}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频描述：</div>
						<div class="" style="width: 80%;">{{addBody.desc}}</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="英文" name="en">
					<div class="flex">
						<div class="title">视频标题：</div>
						<div class="">{{addBody.title_e}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频封面：</div>
						<ImageDetailVue :imgUrl="addBody.icon_e" style="width: 200px;height: auto;"></ImageDetailVue>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频：</div>
						<video autoplay muted controls :src="imgDomain+addBody.file_e" loop width="500" height="300">
						</video>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频URL：</div>
						<a :href="addBody.url_e">{{addBody.url_e}}</a>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">创建时间：</div>
						<div class="">{{addBody.create_time}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频描述：</div>
						<div class="" style="width: 80%;">{{addBody.desc_e}}</div>
					</div>
				</el-tab-pane>
				<el-tab-pane label="日语" name="jp">
					<div class="flex">
						<div class="title">视频标题：</div>
						<div class="">{{addBody.title_j}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频封面：</div>
						<ImageDetailVue :imgUrl="addBody.icon_j" style="width: 200px;height: auto;"></ImageDetailVue>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频：</div>
						<video autoplay muted controls :src="imgDomain+addBody.file_j" loop width="500" height="300">
						</video>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频URL：</div>
						<a :href="addBody.url_j">{{addBody.url_j}}</a>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">创建时间：</div>
						<div class="">{{addBody.create_time}}</div>
					</div>
					<div class="flex" style="margin-top: 20px;">
						<div class="title">视频描述：</div>
						<div class="" style="width: 80%;">{{addBody.desc_j}}</div>
					</div>
				</el-tab-pane>
			</el-tabs>
			<div class="dialog-footer" style="margin-top: 30px;">
				<el-button @click="goBack">返 回</el-button>
				<el-button type="primary" @click="editUser('addBody')">编 辑</el-button>
			</div>
		</el-card>
	</div>
</template>

<script>
	import {
		imgDomain
	} from '@/configs/env';
	import {
		addCvideo,
		editCVideo,
		getCVideo
	} from "@/api/content-manage"
	import ImageUpload from "@/components/ImageUpload"
	import ImageDetailVue from '../../../components/ImageDetail.vue';
	export default {
		components: {
			ImageUpload,
			ImageDetailVue
		},
		data() {
			return {
				imgDomain,
				activeName: 'zh',
				formLabelWidth: '120px',
				addBody: {
					id: '',
					title: '',
					icon: '',
					file: '',
					url: '',
					desc: '',
					title_e: '',
					icon_e: '',
					file_e: '',
					url_e: '',
					desc_e: '',
					title_j: '',
					icon_j: '',
					file_j: '',
					url_j: '',
					desc_j: ''
				},
				fileList: [],
				iconList: [],
				fileListEn: [],
				iconListEn: [],
				fileListJp: [],
				iconListJp: [],
				rules: {
					title: [{
						required: true,
						message: '请输入视频标题',
						trigger: 'blur'
					}, ],
					title_e: [{
						required: true,
						message: '请输入视频标题',
						trigger: 'blur'
					}, ],
					title_j: [{
						required: true,
						message: '请输入视频标题',
						trigger: 'blur'
					}, ],
					file: [{
						required: true,
						message: '请上传视频',
						trigger: 'blur'
					}, ],
					file_e: [{
						required: true,
						message: '请上传视频',
						trigger: 'blur'
					}, ],
					file_j: [{
						required: true,
						message: '请上传视频',
						trigger: 'blur'
					}, ],
					icon: [{
						required: true,
						message: '请上传封面',
						trigger: 'blur'
					}, ],
					url: [{
						required: true,
						message: '请输入视频URL',
						trigger: 'blur'
					}, ],
					desc: [{
						required: true,
						message: '请输入视频描述',
						trigger: 'blur'
					}, ],
					icon_e: [{
						required: true,
						message: '请上传封面',
						trigger: 'blur'
					}, ],
					url_e: [{
						required: true,
						message: '请输入视频URL',
						trigger: 'blur'
					}, ],
					desc_e: [{
						required: true,
						message: '请输入视频描述',
						trigger: 'blur'
					}, ],
					icon_j: [{
						required: true,
						message: '请上传封面',
						trigger: 'blur'
					}, ],
					url_j: [{
						required: true,
						message: '请输入视频URL',
						trigger: 'blur'
					}, ],
					desc_j: [{
						required: true,
						message: '请输入视频描述',
						trigger: 'blur'
					}, ]
				},
			}
		},
		mounted() {
			this.addBody.id = this.$route.query.id
			if (this.addBody.id) {
				this.network().getCVideo()
			}
		},
		methods: {
			handleClick(e, a) {
				this.activeName = e.name
			},
			iconInput(e) {
				this.addBody.icon = e[0]
			},
			fileInput(e) {
				this.addBody.file = e[0]
			},
			iconInputEn(e) {
				this.addBody.icon_e = e[0]
			},
			fileInputEn(e) {
				this.addBody.file_e = e[0]
			},
			iconInputJp(e) {
				this.addBody.icon_j = e[0]
			},
			fileInputJp(e) {
				this.addBody.file_j = e[0]
			},
			goBack() {
				this.$router.go(-1)
			},
			handleImageListChange(list) {
				this.images = list
			},
			isSaleChange(e) {
				this.weight = e
			},
			changeItem(item) {
				this.addBody.roleUuid = item;
			},
			editUser(formName) {
				this.$router.push({
					path: '/add-video-list?id=' + this.addBody.id,
				})
			},
			unShowClick() {
				this.$emit('input', false)
			},
			network() {
				return {
					addCvideo: async () => {
						const {
							status,
							data
						} = await addCvideo({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$message.success('新增成功')
						this.goBack()
					},
					editCVideo: async () => {
						const {
							status
						} = await editCVideo({
							...this.addBody
						})
						if (status !== 200) return
						this.dialog = false
						this.$emit('confirm')
						this.$message.success('修改成功')
						this.goBack()
					},
					getCVideo: async (uuid) => {
						const {
							data,
							status
						} = await getCVideo({
							id: this.addBody.id
						})
						if (status !== 200) return
						this.addBody = data.result
						if (data.result.icon != null) {
							this.iconList.push(data.result.icon)
						}
						if (data.result.file != null) {
							this.fileList.push(data.result.file)
						}
						if (data.result.icon_e != null) {
							this.iconListEn.push(data.result.icon_e)
						}
						if (data.result.file_e != null) {
							this.fileListEn.push(data.result.file_e)
						}
						if (data.result.icon_j != null) {
							this.iconListJp.push(data.result.icon_j)
						}
						if (data.result.file_j != null) {
							this.fileListJp.push(data.result.file_j)
						}
					},
				}
			},
		},
	}
</script>

<style>
	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.title {
		width: 130px;
		color: #999;
	}
</style>